<template>
  <!-- #ValidMerchantTag 用于测试抓去是否为商户 -->
  <div
    v-if="merchantInfo?.merchantStatus || checkMerchant"
    id="ValidMerchantTag"
    :class="{
      buyCryptoMerchant: merchantInfo?.merchantStatus,
      sellCryptoMerchant: checkMerchant,
    }"
    style="display: none"
  ></div>
</template>
<script>
export default {
  props: ["merchantInfo", "checkMerchant"],
};
</script>
